import '../../styles/whatwedo.scss';
import InnerHeader from "../InnerHeader";
import { useTranslation } from "react-i18next";
import OurServices from './OurServices';
import OurOfferings from './OurOfferings';
import ScrollToAnchor from '../../ScrollToAnchor';
import { Col, Container, Row } from 'react-bootstrap';

export default function WhatWeDo(){
    const { t } = useTranslation();
    return(
        <>
            <ScrollToAnchor/>
            <InnerHeader breadcrumb={t(`whatwedo.breadcrumb`)} title={t(`whatwedo.title`)}/>
            <article>
                <section className='whatwedo-intro'>
                    <Container>
                        <Row>
                            <Col>
                                <h3>{t(`whatwedo.intro`)}</h3>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </article>
            <OurServices/>
            <OurOfferings/>
        </>
    )
}